type PaymentMethodLike = {
  pid?: number | string;
  name?: string;
  paymentName?: string;
  title?: string;
  url?: string;
};

const ZIP_PAYMENT_IDS = new Set([18, 29]);

export const ZIP_PAYMENT_ENABLED = false;

export const isZipPaymentMethod = (paymentMethod: PaymentMethodLike) => {
  const paymentId = Number(paymentMethod.pid);
  const paymentName =
    paymentMethod.paymentName || paymentMethod.name || paymentMethod.title || "";

  return (
    ZIP_PAYMENT_IDS.has(paymentId) ||
    /\bzip\s*pay\b|\bzippay\b|\bzip\b/i.test(paymentName) ||
    /\/zip(?:-?pay)?(?:\/|$)/i.test(paymentMethod.url || "")
  );
};

export const isPaymentMethodVisible = (paymentMethod: PaymentMethodLike) =>
  ZIP_PAYMENT_ENABLED || !isZipPaymentMethod(paymentMethod);
